export const ROUTES = {
  HOME: '/home',

  PARTNER: '/partner',
  PARTNER_BUILDING: '/partner/:branchId/building/:buildingId',

  RANKING: '/ranking',
  COMMISSION: '/commission',
  STATISTIC: '/statistic',

  NOTIFY: '/notify',
  DETAIL_NOTIFY: '/notify/:notifyId',

  PROFILE: '/profile',
  EDIT_PROFILE: '/profile/edit',
  HELP_PROFILE: '/profile/help',
  TERM_PROFILE: '/profile/term-condition',
  PRIVACY_PROFILE: '/profile/privacy',
  CONTACT_PROFILE: '/profile/contact',
  ABOUT: '/about',

  ROOM_DETAIL: '/partner/:branchId/building/:buildingId/room/:roomId',

  LOGIN: '/login',
};
